<script lang="ts">
    import { onMount } from 'svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Content from '../../_common/content.svelte'
    import Fa from 'svelte-fa'
    import { faSave } from '@fortawesome/free-solid-svg-icons'
    import type { User } from '../../../modules/usersApi/users/user'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import ZinputTitle from '../../_common/z/zinput-title.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import ZinputBreak from '../../_common/z/zinput-break.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import type { UpdatePasswordDto } from '../../../modules/usersApi/auth/dto/update-password.dto'

    let user: User = null
    async function load() {
        user = await window.api.users.users.getOne(window.store.token.userId)
        console.log('user', user)
    }

    let show = false
    let newPass1: string = ''
    let newPass2: string = ''
    let oldPass: string = ''

    async function changePassword() {
        if (!newPass1 || !newPass2 || !oldPass) {
            window.error('Todos os campos devem ser preenchidos.')
            return
        }
        if (newPass1.length < 6) {
            window.error('Sua nova senha deve possuir ao menos 6 caracteres.')
            return
        }
        if (newPass1 != newPass2) {
            window.error('A nova senha não confere com a confirmação.')
            return
        }
        const data: UpdatePasswordDto = {
            newPassword: newPass1,
            oldPassword: oldPass,
        }
        try {
            show = true
            const result = await window.api.users.auth.updatePassword(data)
            console.log('result', result)
            location.href = '/resources/password-change-success'
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    let granted = false

    onMount(async () => {
        await load()
    })

    function onGranted() {
        console.log('granted received')
        granted = true
    }
</script>

<LoadSpinner {show}></LoadSpinner>
{#if user}
    <Content>
        <Zact>
            <div class="spacer" />
            <button class="btn btn-primary" on:click={changePassword}><Fa icon={faSave} /> Salvar</button>
        </Zact>
        <Zframe title="Alterar senha" class="mt-3">
            <div class="box-change-pass">
                <ZContainer>
                    <ZinputTitle title="Dados atuais"></ZinputTitle>
                    <Zinput label="Você está logado como" bind:value={user.phone} disabled={true}></Zinput>
                    <ZinputBreak></ZinputBreak>
                    <Zinput label="Sua senha ATUAL" type="password" bind:value={oldPass}></Zinput>
                    <ZinputBreak></ZinputBreak>
                    <ZinputTitle title="Nova senha"></ZinputTitle>
                    <Zinput label="Escolha uma nova senha" type="password" bind:value={newPass1}></Zinput>
                    <ZinputBreak></ZinputBreak>
                    <Zinput label="Repita a nova senha" type="password" bind:value={newPass2}></Zinput>
                    <ZinputBreak></ZinputBreak>
                </ZContainer>
            </div>
        </Zframe>
    </Content>
{/if}

<style>
    .box-change-pass {
        max-width: 512px;
        margin: 0 auto;
        background-color: #99999920;
        padding: 8px;
        border-radius: 8px;
        margin-top: 16px;
    }
</style>
